import type { ReactChild, ReactElement } from 'react';

import { cn } from 'helpers/classnames';
import UtilityDottedTrueToSizeMediumIcon from 'tailwind/components/Icons/UtilityDottedTrueToSizeMediumIcon';

export interface RecommendedSizingLayoutProps {
  isHydraSizePrediction: boolean;
  backgroundColor: 'green' | 'yellow';
  children?: ReactChild;
}

const RecommendedSizingLayout = ({ isHydraSizePrediction, backgroundColor, children }: RecommendedSizingLayoutProps): ReactElement => {
  if (!isHydraSizePrediction) {
    return <>{children}</>;
  }

  const backgroundClasses = backgroundColor === 'green' ? 'bg-[theme(colors.green.200)]' : 'bg-[theme(colors.yellow.200)]';

  return (
    <div className="flex h-fit w-fit items-center gap-x-2">
      <div className={cn(backgroundClasses, 'rounded-full p-2')}>
        <UtilityDottedTrueToSizeMediumIcon size={24} />
      </div>
      {children}
    </div>
  );
};

export default RecommendedSizingLayout;
